import http from "infra/http";
import { useQuery } from "react-query";
import { TipoNotificacaoResponse } from "../typings";

function useTiposNotificacoes() {
  return useQuery([`/v1/notificacao-cobranca/tipos`], async () => {
    const { data } = await http.get<TipoNotificacaoResponse[]>(
      `/v1/notificacao-cobranca/tipos`
    );
    return data;
  });
}

export default useTiposNotificacoes;
